import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetUserVoucherInstancesResponse, UserVoucherInstance } from '@picard/models-lib';
import { ApplicationService, BreadcrumbService, DashboardService } from '@picard/services-lib';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent implements OnInit {

  //#region Properties
  loadedVouchersPanel: boolean;
  @BlockUI() blockUI: NgBlockUI;
  getUserVoucherInstancesResponse: GetUserVoucherInstancesResponse;
  voucherInstances: UserVoucherInstance[];
  p = 1;
  //#endregion Properties

  constructor(private _router: Router, private _breadcrumbService: BreadcrumbService, private _applicationService: ApplicationService, private _dashboardService: DashboardService) { 
    this._breadcrumbService.setItems([{ label: 'Vouchers', routerLink: '/vouchers' }]);
  }

  async ngOnInit() {
    try{
      this.blockUI.start('Loading vouchers.');
        const getUserVoucherInstancesResponseInitialResponse: GetUserVoucherInstancesResponse = (this.getUserVoucherInstancesResponse = await this._dashboardService.GetUserVoucherInstancesAsync());
        this.voucherInstances = getUserVoucherInstancesResponseInitialResponse.voucherInstances.filter(function(e) { return !e.shortDescription.includes('Wallet')});
        this.voucherInstances = this.voucherInstances.sort(function (a: any, b: any) { 
          return a.voucherInstanceId - b.voucherInstanceId; 
        }).reverse();
        sessionStorage.setItem("userVoucherInstances", JSON.stringify(this.voucherInstances));
        this.blockUI.stop();
        this.loadedVouchersPanel = true;
    }catch (error) {
      this.loadedVouchersPanel = false;
      this.blockUI.stop();
      console.log(error);
    }
  }

  openVoucherDetials(voucherInstanceId: number){
    this._router.navigateByUrl(`/vouchers/${voucherInstanceId}`);
  }

  getFormattedDate(dateString: string){
    if (dateString == "") return dateString
    let date = new Date(dateString);
    return date.toDateString();
  }

  getStatus(voucherStatusId: number){
    let vStatus: string;
    switch(voucherStatusId){
      case 1:
        vStatus = 'Activated';
        break;
      case 2:
        vStatus = 'ACTIVE';
        break;
      case 3:
        vStatus = 'REDEEMED';
        break;
      case 4:
        vStatus = 'EXPIRED';
        break;
      case 5:
        vStatus = 'CANCELLED';
        break;
      case 6:
        vStatus = 'GIFTED';
        break;
      case 7:
        vStatus = 'ACTIVE';
        break;
      default:
        vStatus = 'Unknown';
    }
    return vStatus;
  }
}
